import React from "react";
import styles from "../../pages/JobDetails/Jobdetails.module.css";
import Tooltip from "@atlaskit/tooltip";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import EditorErrorIcon from "@atlaskit/icon/glyph/editor/error";
import Spinner from "@atlaskit/spinner";
import EmojiFrequentIcon from "@atlaskit/icon/glyph/emoji/frequent";
import Lozenge from "@atlaskit/lozenge";
import CheckCircleIcon from "@atlaskit/icon/glyph/check-circle";
import Skeleton from "react-loading-skeleton";

const BackupConfigJobDetails = ({
  jobStatus,
  screensMetadata,
  isLoading,
  workflowsMetadata,
}) => {
  return (
    <div className={styles.secondcontentgridcontainer}>
      <div className={styles.cardcontainer}>
        <div className={styles.card}>
          <div className={styles.cardTitle}>
            <Tooltip
              content={jobStatus[screensMetadata?.status]}
              position="left"
            >
              <div>
                {screensMetadata?.status === 1 && <EmojiFrequentIcon />}
                {screensMetadata?.status === 2 && <Spinner />}
                {screensMetadata?.status === 3 && (
                  <CheckCircleIcon primaryColor="green" />
                )}
                {screensMetadata?.status === 4 && (
                  <WarningIcon primaryColor="orange" />
                )}
                {screensMetadata?.status === 5 && (
                  <EditorErrorIcon primaryColor="red" />
                )}
              </div>
            </Tooltip>
            <strong>Workflows </strong>
          </div>
          <hr />
          {screensMetadata?.status === 5 ? (
            <h5 className={styles.carddetails}>No data found</h5>
          ) : (
            <div className={styles.carddetails}>
              <div className={styles.smolgrid}>
                <p>Transitions count &nbsp;</p>
                <div>
                  {isLoading ? (
                    <Skeleton width={50} />
                  ) : (
                    <Lozenge isBold>
                      {workflowsMetadata?.totalTransitionsCount}
                    </Lozenge>
                  )}
                </div>
              </div>
              <div className={styles.smolgrid}>
                <p>Workflows count &nbsp;</p>
                <div>
                  {isLoading ? (
                    <Skeleton width={50} />
                  ) : (
                    <Lozenge isBold>
                      {workflowsMetadata?.totalWorkflowsCount}
                    </Lozenge>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.cardcontainer}>
        <div className={styles.card}>
          <div className={styles.cardTitle}>
            <Tooltip
              content={jobStatus[screensMetadata?.status]}
              position="left"
            >
              <div>
                {screensMetadata?.status === 1 && <EmojiFrequentIcon />}
                {screensMetadata?.status === 2 && <Spinner />}
                {screensMetadata?.status === 3 && (
                  <CheckCircleIcon primaryColor="green" />
                )}
                {screensMetadata?.status === 4 && (
                  <WarningIcon primaryColor="orange" />
                )}
                {screensMetadata?.status === 5 && (
                  <EditorErrorIcon primaryColor="red" />
                )}
              </div>
            </Tooltip>
            <strong>Screens </strong>
          </div>
          <hr />
          {screensMetadata?.status === 5 ? (
            <h5 className={styles.carddetails}>No data found</h5>
          ) : (
            <div className={styles.carddetails}>
              <div className={styles.smolgrid}>
                <p>Screens count &nbsp;</p>
                <div>
                  {isLoading ? (
                    <Skeleton width={50} />
                  ) : (
                    <Lozenge isBold>
                      {screensMetadata?.totalScreensCount}
                    </Lozenge>
                  )}
                </div>
              </div>
              {/* <div className={styles.smolgrid}>
          <p>Screen Size &nbsp;</p>
          <div>
            {isLoading ? (
              <Skeleton width={50} />
            ) : (
              <Lozenge isBold>{screensMetadata.totalScreensSize}</Lozenge>
            )}
          </div>
        </div> */}
              <div className={styles.smolgrid}>
                <p>Tabs count : &nbsp;</p>
                <div>
                  {isLoading ? (
                    <Skeleton width={50} />
                  ) : (
                    <Lozenge isBold>{screensMetadata?.totalTabsCount}</Lozenge>
                  )}
                </div>
              </div>
              <div className={styles.smolgrid}>
                <p>Tab fields count : &nbsp;</p>
                <div>
                  {isLoading ? (
                    <Skeleton width={50} />
                  ) : (
                    <Lozenge isBold>
                      {screensMetadata?.totalTabsFieldsCount}
                    </Lozenge>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BackupConfigJobDetails;
